import { apiFetch } from "./client";

const fetchCategories = async () => {
  try {
    return await apiFetch("/api/categories");
  } catch (err) {
    console.warn("Unable to load categories", err);
    return [];
  }
};

const createCategory = async (payload) => {
  const name = payload?.name?.trim();
  if (!name) {
    throw new Error("Category name is required");
  }

  return apiFetch("/api/categories", {
    method: "POST",
    body: JSON.stringify({ name }),
  });
};

const deleteCategory = async (id) => apiFetch(`/api/categories/${id}`, { method: "DELETE" });

export { fetchCategories, createCategory, deleteCategory };
